module.exports = __webpack_public_path__ + "static/media/meter_block_white.d1b50719.png";